/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "compositeep",
            "endpoint": "https://m5xjg9zsl7.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        },
        {
            "name": "ibg",
            "endpoint": "https://0f2abhexn1.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-1:a6b04f34-d8f6-4eac-abad-75daf6db1186",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_sddRXtCeK",
    "aws_user_pools_web_client_id": "5inem0qkt9g659s2k5gg1fk4eu",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "us-east-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "compositedb-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "dlzpserverlessubsclogstable-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "subscriptionIDs-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "subscriptionspackages-dev",
            "region": "us-east-1"
        }
    ],
    "aws_user_files_s3_bucket": "dlzpserverlesssubscr7878e674827e408e924b9012359133504-dev",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
